<template>
  <el-row
    :gutter="20"
    style="margin-bottom: 0"
  >
    <custom-select
      v-model="recursoValue"
      :label="''"
      :span="5"
      :settings="{
        placeholder: proceso.ProcesoEtiquetas?.Recurso || 'Seleccionar maquina',
        options: recursosConDisponibilidad,
        clearable: true,
      }"
    />

    <custom-input-number
      v-if="proceso.PorcentajeMerma"
      v-model="porcentajeMermaValue"
      :span="3"
      :label="proceso.ProcesoEtiquetas?.PorcentajeMerma || '% Merma'"
      :settings="{
        placeholder: proceso.ProcesoEtiquetas?.PorcentajeMerma || '% Merma',
        min: 0,
        precision: 2,
        step: 1,
        controls: false,
      }"
      class="w-70"
    />

    <custom-input-number
      v-if="proceso.Velocidad"
      v-model="velocidadValue"
      :span="3"
      :label="proceso.ProcesoEtiquetas?.Velocidad || 'Velocidad'"
      :settings="{
        placeholder: proceso.ProcesoEtiquetas?.Velocidad || 'Velocidad',
        min: 0,
        precision: 0,
        step: 1,
        controls: false,
      }"
      class="w-70"
    />
  </el-row>
</template>

<script setup>
import { computed } from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  proceso: {
    type: Object,
    required: true,
  },
  recursos: { type: Array, default: () => [] },
  recurso: { type: Object },
  isItemDisabled: { type: Function, default: null },
});

const recursosConDisponibilidad = computed(() => {
  return props.recursos.map((recurso) => {
    const disabled = props.isItemDisabled ? !!props.isItemDisabled(recurso) : false;
    return disabled ? { ...recurso, disabled: true } : recurso;
  });
});

const emits = defineEmits(['update:modelValue']);

const porcentajeMermaValue = computed({
  get() {
    return props.modelValue.PorcentajeMerma;
  },
  set(value) {
    const newValue = { ...props.modelValue, PorcentajeMerma: value };
    emits('update:modelValue', newValue);
  },
});

const velocidadValue = computed({
  get() {
    return props.modelValue.Velocidad;
  },
  set(value) {
    const newValue = { ...props.modelValue, Velocidad: value };
    emits('update:modelValue', newValue);
  },
});

const recursoValue = computed({
  get() {
    return props.modelValue.Recurso;
  },
  set(value) {
    const newValue = { ...props.modelValue, Recurso: value };
    emits('update:modelValue', newValue);
  },
});
</script>
